<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabContactMixin, vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js"
import { omit } from 'lodash';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabContactMixin, vodafoneLabBasicMixin],
  data: function () {
    return { };
  },
  methods: {
  },
  computed: {
    headingMediaContent() {
      const content = omit(this. content, ['subtitle', 'share']);
      return { ...{ height: '60vh', text_align: 'center', theme: 'dark' }, 
               ...content };
    },
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 7);
      return [
        `col-lg-${columnWidth}`
      ];
    }
  }
};
</script>

<template>
  <div 
    v-if="isContentVisibleToUser()" 
    v-easyadmin="easyadminId" 
    :class="contentType"
    page-article
    page-article-heading-media-component
    class="position-relative"
  >
    <breadcrumb :breadcrumb="pageModel.breadcrumb"></breadcrumb>
    <heading-media :content="headingMediaContent" :opt-container-content="containerContent"></heading-media>
    <div class="mb-4 mb-md-5">
      <stripe-article-interactions
        v-if="content.share"
        class="justify-content-end"
        :content="content"
        :opt-container-content="containerContent"
      ></stripe-article-interactions>
      <page-article-red-banner :content="content.red_banner" :opt-container-content="containerContent" v-if="content.red_banner"></page-article-red-banner>
    </div>
    <div class="container mt-4" v-if="lastUpdatedAt">
      <div class="row justify-content-center">
        <div class="col-lg-7 small">{{ft('globals.updated_at')}} {{lastUpdatedAt}}</div>
      </div>
    </div>
    <component
      :key="stripe.$id"
      :content="stripe"
      :is="stripe.layout"
      :opt-container-content="containerContent"
      :width="7"
      v-for="(stripe) in content.stripes"
    ></component>
    <div class="container py-4 py-md-5" v-if="content.decorators['category']">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-7">
          <div class="d-flex flex-wrap">
            <a v-for="category in (content.decorators['category'] || [])" class="btn btn-sm btn-outline-primary rounded-pill px-3 py-1 mx-2" :href="applyContextToUrl(pageModel.decorators.category[category].slug)">
              {{pageModel.decorators.category[category].title}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <vote-interaction class="mb-md-5 pb-3" :content="content" v-if="content.vote"></vote-interaction>
    <related-collections :content="content"></related-collections>
    <stripe-contact-us :content="contactStripe" v-if="contactStripe"></stripe-contact-us>
  </div>
</template>

<style lang="scss" scoped>
[page-article-heading-media-component] {

  .author-image {
    max-height: 5rem;
    max-width: 10rem;
    height: auto;
    width: auto;
    display: inline-block;
  }

  ::v-deep [heading-media-component] .category {
    display: none !important;
  }
}
</style>
